var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.icon,{tag:"component",staticClass:"icon-gateway",class:_vm.health})}
var staticRenderFns = []

export { render, staticRenderFns }